export const isMissingCompletePreferencesError = (error) =>
  error?.code === "42P01" ||
  error?.code === "PGRST205" ||
  /complete_mode_preferences/i.test(error?.message || "");

export const isMissingCommonBaseError = (error) =>
  error?.code === "42P01" ||
  error?.code === "PGRST205" ||
  /common_base/i.test(error?.message || "");

export const isMissingCompletePreferenceBuyInColumnsError = (error) =>
  error?.code === "42703" &&
  /buy_in_min_cents|buy_in_max_cents/i.test(error?.message || "");

export const isMissingCompletePreferenceOnboardingColumnError = (error) =>
  error?.code === "42703" &&
  /onboarding_completed_at/i.test(error?.message || "");

export const isMissingTicketValueError = (error) =>
  (error?.code === "42703" || error?.code === "PGRST204") &&
  /ticket_value_cents|ticket_value_currency/i.test(error?.message || "");

export const isMissingWithdrawnCentsError = (error) =>
  error?.code === "42703" || /withdrawn_cents/i.test(error?.message || "");

export const isMissingDepositedCentsError = (error) =>
  error?.code === "42703" || /deposited_cents/i.test(error?.message || "");

export const isMissingAliasError = (error) =>
  error?.code === "42703" || /\balias\b/i.test(error?.message || "");

export const isMissingCurrencyColumnError = (error) =>
  error?.code === "42703" &&
  /currency|buy_in_currency|ticket_value_currency|prize_currency|balance_currency|withdrawn_currency|deposited_currency/i.test(
    error?.message || ""
  );

export const isMissingSnapshotBaseColumnError = (error) =>
  (error?.code === "42703" || error?.code === "PGRST204") &&
  /base_bankroll_cents/i.test(error?.message || "");
